import { HTMLElementType, NFIdentity, TagCategory, ValueType } from '@nibras/core/common';
import { dcDataReference } from './dcdataReference.model';
import { dcSearchTags } from './dcSearchTags.model';
import { dcTag } from './dcTag.model';
import { HeaderAction } from './header-action.model';
import { DataMethods } from './response/data-method.enum';

export class AppConstants {
  //#region Common
  public static readonly DATE_FORMAT = 'dd-MMM-yyyy';
  public static readonly DELETE_CONFIRM_MSG = 'Are you sure to Delete';
  public static readonly DELETED_TITLE = 'Deleted';
  public static readonly DELETE_DEFAULT_BUTTON_TEXT = 'Delete';
  public static readonly SAVED_TITLE = 'Saved';
  public static readonly DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: 'numeric'
  };
  public static readonly APP_TAG_TYPE_IDs = [2005];

  //Below 4 are used in adduser component only.
  public static readonly DATE_MONTH_YEAR_LABEL = 'MMM yyyy';
  public static readonly DATE_A11Y_LABEL = 'LL';
  public static readonly DATE_MONTH_YEAR_A11Y_LABEL = 'MMMM YYYY';

  //Below 6 are used in Sankey component only.
  public static readonly YYYY_FORMAT = 'YYYY';
  public static readonly MMYYYY_FORMAT = 'MMM-YYYY';
  public static readonly DDMMYYYY_FORMAT = 'DD-MM-YYYY';
  public static readonly DDMMYYYYHHmm_FORMAT = 'DD-MM-YYYY HH:mm';
  public static readonly WW_FORMAT = 'ww';
  public static readonly MONTHLY_DATE_FORMAT = 'DD-MMM';
  public static readonly DDMMYYYYHHmmss_FORMAT = 'DD-MM-YYYY HH:mm:ss'; //Used in Trend-report also, can be removed - Need to check.
  public static readonly YYYYMMDDTHHmmss_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

  // eslint-disable-next-line max-len
  public static readonly SORT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'; //Used on Trend app only, No impact in UI. Used only for Sorting - Need to remove later.
  // eslint-disable-next-line max-len
  public static readonly ISO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss'; //Used on Schedule design only, No impact in UI. Used only for formating data from client and send to API - API date format should be in ISO format. Need to use the common method here.
  public static readonly DATE_TIME_FORMAT = `${AppConstants.DATE_FORMAT} hh:mm a`;

  public static readonly ddMMyyyy_FORMAT = 'dd-MM-yyyy';
  public static readonly ddMMYYYYHHmm_FORMAT = 'dd-MM-yyyy HH:mm';
  public static readonly ddMMYYYYHHmmss_FORMAT = 'dd-MM-yyyy HH:mm:ss';
  public static readonly ddMMYYYYHHmma_FORMAT = 'MM/DD/YYYY, hh:mm a';
  public static readonly ddMMYYYY_FORMAT = 'MM/DD/YYYY';

  public static readonly DATA_ACTION_TYPE = 'data-action-type';
  public static readonly COMPONENT_HEADER_HEIGHT = 40;
  public static readonly RESULT_SLICE_MIN_LIMIT = 10;
  public static readonly MIN_VALUE = 0;
  public static readonly RESULT_SLICE_MAX_LIMIT = 1000;
  public static readonly CUMULATIVE_COLUMN = 'Cumulative_';
  public static readonly RECORD_COUNT = 'RecordCount';
  public static readonly ELEMENT_NAME = 'ElementName';
  public static readonly SHOW_CONTROL = 'showControl';
  public static readonly HIDE_CONTROL = 'hideControl';
  public static readonly HIDDEN = 'hidden';
  public static readonly ORDER = 'order';
  public static readonly SANKEY_TITLE_TEXT = 'Group Analysis by ';
  public static readonly TIMESTAMP_TEXT = 'TimeStamp';
  public static readonly Filter_TIMESTAMP_TEXT = 'FilterTimeStamp';
  public static readonly HISTORICAL_TEXT = 'Historical Analysis by ';
  public static readonly MONTHS_TEXT = 'months';
  public static readonly YEARS_TEXT = 'years';
  public static readonly MINUTES_TEXT = 'minutes';
  public static readonly HOURS_TEXT = 'hours';
  public static readonly DAYS_TEXT = 'days';
  public static readonly WEEKS_TEXT = 'weeks';
  public static readonly WEEK_TEXT = 'Week - ';
  public static readonly DASH_OPERATOR = '-';
  public static readonly COLON_OPERATOR = ':';
  public static readonly DATE_SAPERTATOR = AppConstants.COLON_OPERATOR;
  public static readonly SPACE_OPERATOR = ' ';
  public static readonly PIPE_OPERATOR = '|';
  public static readonly EQUALS_TEXT = 'equals';
  public static readonly EXIT_TEXT = 'exit';
  public static readonly MINIMIZE_SCREEN_TEXT = 'minimizescreen';
  public static readonly SHOW_MAXIMIZE_SCREEN_TEXT = 'showMaximizeScreen';
  public static readonly DATA_TEXT = 'Data';
  public static readonly Precision = 'Precision';
  public static readonly TREND_TEXT = 'trend';
  public static readonly SANKEY_TEXT = 'sankey';
  public static readonly FULL_SCREEN_TEXT = 'fullscreen';
  public static readonly SERIES_TEXT = 'series';
  public static readonly MONTHLY_TEXT = 'Monthly';
  public static readonly YEARLY_TEXT = 'Yearly';
  public static readonly MINUTE_TEXT = 'Minutes';
  public static readonly HOURLY_TEXT = 'Hourly';
  public static readonly DAILY_TEXT = 'Daily';
  public static readonly WEEKLY_TEXT = 'Weekly';
  public static readonly TOTAL_TEXT = 'Total';
  public static readonly VALUE_TEXT = 'Value';
  public static readonly DATE_TEXT = 'date';
  public static readonly INVALID_DATE_TEXT = 'Invalid Date';
  public static readonly HAS_CHILDREN = 'hasChildren';
  public static readonly LEAF_NODE = 'leafNode';
  public static readonly DEFAULT_EXTERNAL_PARAMETER_INTERVAL_VALUE: number = 200;
  public static readonly NO_DATA_TEXT = 'no data';
  public static readonly CONDITION_FORMATTING_COLUMNS_PREFIX = '__';
  public static DecimalPrecison = 2;
  public static readonly ID_TEXT = 'ID';
  public static readonly NONE_TEXT = 'none';
  public static readonly MONTH_TEXT = 'Month';
  public static readonly YEAR_TEXT = 'Year';
  public static readonly INVALID_SYNTAX = 'Invalid syntax';
  public static readonly ChartTypeCat_Text = 'category';
  public static readonly ChartTypeSeries_Text = 'series';
  public static readonly NoData_Text = 'No Data';
  public static readonly JSON_NODATA = 'NoData';
  public static readonly BAD_DATA = 'BAD_DATA';
  public static readonly AGGREGATECONSTANTSUM: string = 'sum';
  public static readonly STRINGCOLUMNS: string = 'columns';
  public static readonly STRINGTOTAL: string = 'total';
  public static readonly STRINGNAME: string = 'Name';
  public static readonly COMPONENT_TEXT = 'component';
  public static readonly COMPOENENT_Z_INDEX = '2';
  public static readonly CHILD_ELEMENT_DEFAULT_PATH = '.';
  public static readonly defaultSeries = 1;
  public static readonly TIME_TEXT = 'time';
  public static readonly REF_ELEMENT_NAME = 'RefElementName';
  public static readonly PREV_ACTIVITY_REMARK = 'PreviousActivityRemark';
  public static readonly N_A = 'N/A';
  public static readonly NaN_TEXT = 'NaN';
  public static readonly Nodata_Text = 'No data';
  public static readonly ATTRIBUTE_DOES_TEXT = `Attribute doesn't exist`;
  public static readonly ATTRIBUTE_NOT_FOUND = 'Attribute not found';
  public static readonly ELEMENT_NOT_FOUND = 'Element not found';
  public static readonly INVALID_VALUE_TYPE = 'Invalid value type';
  public static readonly DEFAULT_GRID_COLUMNS = 12;
  public static readonly DEFAULT_ROW_SPAN = 6;
  public static readonly COMPONENTS_PER_ROW = 1;
  public static readonly TABLE_FILTER_NONE_KEY = 'None Selected';
  public static readonly ELEMENT_NAME_DISPLAY = 'Element Name';
  public static readonly RECORD_COUNT_DISPLAY = 'Record Count';
  public static readonly APPLICATION_STORE_ROUTE = 'app-store';
  public static readonly ZOOM_ICON = 'hdr_strong';
  public static readonly SETTING_ICON = 'Setting';
  public static readonly REFRESH_ICON = 'Refresh';
  public static readonly EVENT_TARGET = 'target';
  public static readonly HAS_CHILD_REQUEST = 'HasChildRequests';
  public static readonly ALL_TAG_TEXT = 'ALL';
  public static readonly PROCESS_LINK = ' Process Link';
  public static readonly UOM_TEXT = 'Units of measurement';
  public static readonly ATTRIBUTE_TEMPLATE_TEXT = 'Attribute Template';
  public static readonly ACTIONS_COLUMN: string = 'Actions';

  public static readonly PDF_CONSTANTS = {
    VIEW_FILE: 'viewFile/',
    TABLE_HEADER_INFORMATION: 'Header Information',
    TIME_RANGE: 'Time Range',
    PRINT_DATE: 'Print Date'
  };
  public static readonly MAXIMIZE_HEADER_ACTION: HeaderAction = {
    icon: 'fullscreen',
    title: 'Show Full Screen',
    action: 'toggle-fullscreen',
    group: 'toggle-fullscreen',
    isActive: false,
    showActiveColor: true,
    type: HTMLElementType.button,
    isKeyAction: true,
    activeItem: {
      icon: 'fullscreen_exit',
      title: 'Exit Full Screen',
      action: 'toggle-fullscreen'
    }
  };

  public static readonly SOP_VIEWER_BUTTON_ACTION = {
    isKeyAction: true,
    title: 'SOP',
    group: 'sop-preview',
    icon: 'fullscreen',
    isActive: false,
    showActiveColor: true,
    type: HTMLElementType.sopViewerButton
  } as HeaderAction;

  public static readonly LAST_SPEED_TESTED_ON = 'LAST_SPEED_TESTED_ON';
  public static readonly SPEED_TESTED_INTERVAL_DAYS = 7;
  public static readonly FORCE_TRANSPORT_TYPE = 'FORCE_TRANSPORT_TYPE';
  public static readonly SIGNALR_RECONNECT_COUNT = 2;

  public static readonly ELEMENT_SELECTOR_APP_ID = 944541;
  public static readonly ELEMENT_SELECTOR_WIDGET_ID = 944745;
  public static readonly SELECTED_ROLE_ID_KEY = 'selectedRoleId';

  public static readonly TREND_ALIGNMENT_RIGHT = 1;
  public static readonly TREND_ALIGNMENT_LEFT = 2;

  public static readonly WORKFLOW_APP_TAG = {
    TagID: 2985,
    TagName: 'WORKFLOWDESIGNER',
    ElementTypeID: NFIdentity.App
  } as dcTag;
  public static readonly APPLICATION_DASHBOARD_ROUTE = 'dashboard';
  public static readonly APP_STORE_APP_ID = 10013;
  public static readonly DX_MANAGER_APP_ID = 10000;
  public static readonly EVENT_VIEWER_APP_ID = 40000;
  public static readonly USER_ROLE_ASSIGNMENT_APP_ID = 5130;
  public static readonly EBS_MANAGEMENT_APP_ID = 5286;

  public static readonly BROWSER_FULLSCREEN = 'browser-fullscreen';

  public static readonly STATIC_WORKFLOW_APP_ID = 2985;
  public static NAV_MENU_EXCLUDED_APP_IDs: number[] = [
    AppConstants.APP_STORE_APP_ID
    //,    WorkflowTemplates.TaskDashBoard
  ];
  public static IGNORE_SECURITYCHECK_APPS = [AppConstants.APP_STORE_APP_ID];

  public static DEFAULT_APP_ICON = 'apps_grid';

  public static TAB_LABELS = {
    TASKS: 'Tasks',
    CONNECTIONS: 'Connections',
    KEY_PERFORMANCE_INDICATORS: 'Key Performance Indicators'
  };
  //#endregion Common

  public static readonly LOADING_STRING = 'Loading...';
  public static readonly TASK_SUMMARY = '0 Task(s) on 0 Element(s)';
  public static readonly IS_CHILD_REQUESTS_LOADING = 'isChildRequestsLoading';
  public static readonly INFINITY_STRING = 'Infinity';
  public static readonly UOM_M3D = ' (m3/d)';
  public static EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;';
  public static EXCEL_EXTENSION = '.xlsx';

  public static readonly CUSTOM_STRING = 'Custom';
  public static UIBreakPoints = {
    MAIN_BREAK_POINT: 'gt-md',
    MAIN_BREAK_POINT_QUERY: 'screen and (min-width: 1280px)',
    MEDIUM_SCREEN: 'gt-sm',
    SMALL_SCREEN: 'sm'
  };

  public static RoleNames = {
    NibrasGuest: 'Nibras Guest',
    Nibras_Guest: 'NIBRAS_GUEST'
  };

  public static RolePermissionCategory = {
    READ_ONLY: 'ReadOnly',
    READ_WRITE: 'ReadWrite'
  };
  public static AttributeTemplateVersionIds = {
    // DATASOURCE: 134,
    // DATAFUNCTION: 16,
    // FormulaInputParameterName: 18
  };
  public static SDKTemplates = {
    BT_File: 'BT_File'
  };

  public static AttributeDefaultValues = {
    TAGNAME_FORMAT_DEAFULT_VALUE: '%TagName%'
  };
  public static ATTRIBUTE_ORDER_BY_FIELD = 'Header.AttributeTemplateName';
  public static TIME_SERIES_DATAMETHODS = [DataMethods.PlotValues, DataMethods.InterpolatedValues];

  private static ELEMENT_VERSION_ID = 'ElementVersionID';
  private static PROCESS_INSTANCEID = 'ProcessInstanceID';
  public static NEW_PROCESS_INSTANCE_ID = -1;

  public static AttributeNames = {
    ATTRIBUTE_TEMPLATE_VERSION_ID: 'AttributeTemplateVersionID',
    ELEMENT_TYPE_ID: 'ElementTypeID',
    UOM: 'UOM',
    ROOT_ELEMENT_TEMPLATE_ID: 'RootElementTemplateID',
    ROOT_ELEMENT_VERSION_ID: 'RootElementVersionID',
    ATTRIBUTE_PATH: 'AttributePath',
    DATA_SOURCE: 'DataSource',
    DATA_METHOD: 'DataMethod',
    INPUT_NAME: 'InputName',
    START_DATE: 'StartDate',
    END_DATE: 'EndDate',
    DATE_FILTER_MODE: 'DateFilterMode',
    OWNER: 'OWNER',
    OBJECTIVE: 'OBJECTIVE',
    CUSTODIAN: 'CUSTODIAN',
    USER_GUIDE: 'USER_GUIDE',
    IS_GROUP: 'Is_Group',
    SUPPORTED_TEMPLATE: 'SupportedTemplate',
    SUPPORTED_PORT_TEMPLATE: 'SupportedPortTemplate',
    ORDER: 'Order',
    ICON: 'Icon',
    APP_ICON: 'Icon',
    WIDGET_NAME: 'WidgetName',
    COLUMNS: 'Columns',
    ROWS: 'Rows',
    X_POSITION: 'xposition',
    Y_POSITION: 'yposition',
    APP_NAME: 'AppName',
    SUPPORTED_TYPE: 'SupportedType',
    GRID_MODE: 'GRID_MODE',
    INCLUDE_WORKFLOW_DATA: 'IncludeWorkflowData',
    NAME: 'Name',
    LABEL: 'LABEL',
    AXIS_ID: 'AXISID',
    AUTO_SCALE_MIN: 'AutoScaleMin',
    AUTO_SCALE_MAX: 'AutoScaleMax',
    GROUP: 'group',
    ISARRAYDATAVALUE: 'IsArrayDataValue',
    WATER: 'Water',
    OIL: 'Oil',
    CONDENSATE: 'Condensate',
    GROSS: 'Gross',
    TOTALGAS: 'Total_Gas',
    FORMATIONGAS: 'Formation_Gas',
    LIFTGAS: 'Lift_Gas',
    ROOTELEMENTNAME: 'ROOTELEMENTNAME',
    ELEMENT_VERSION_ID: AppConstants.ELEMENT_VERSION_ID,
    PROCESS_INSTANCEID: AppConstants.PROCESS_INSTANCEID,
    ELEMENT_VERSION_ID_PROCESS_INSTANCEID:
      AppConstants.ELEMENT_VERSION_ID + '_' + AppConstants.PROCESS_INSTANCEID,
    ELEMENTNAME: 'ElementName',
    FILEDATA: 'FileData'.toLowerCase(),
    VISUALIZATIONTYPE: 'VisualizationType',
    FILE_CATEGORY: 'Category'.toLowerCase(),
    FORMATTING1: 'Formatting1',
    FORMATTING2: 'Formatting2',
    FORMATTING3: 'Formatting3',
    ELEMENT_PATH: 'ElementPath',
    CONTENT: 'Content',
    DESTINATION_ATTRIBUTE_NAME: 'DestinationAttributeName',
    DESTINATION_ATTRIBUTE_PATH: 'DestinationAttributePath',
    DESTINATION_ELEMENT_PATH: 'DestinationElementPath',
    PERSISTENT_ATTRIBUTE_NAME: 'PersistentAttributeName',
    PERSISTENT_ATTRIBUTE_PATH: 'PersistentAttributePath',
    PERSISTENT_ELEMENT_PATH: 'PersistentElementPath',
    PERSISTENT_TEMPLATE_ID: 'PersistentTemplateID',
    DEFAULT_ELEMENTVERSIONID: 'DefaultElementVersionID',
    RULE_ELEMENTVERSION_ID: 'RuleElementVersionID',
    IS_CUSTOM_APP: 'IsCustomApp',
    ISEXISTINGAPP: 'IsExistingApp',
    LINKED_APPs: 'LinkedApps',
    PROCESS_PRIORITY: 'ProcessPriority',
    MOBILE_ENABLED: 'MobileEnabled',
    ALLOW_DUPLICATE: 'AllowDuplicate',
    PROCESS_TYPE: 'ProcessType',
    MATURATION_TIME: 'MaturationTime',
    RETENTION_TIME: 'RetentionTime',
    PROCESS_ELEMENT_ID: 'ProcessElementVersionID',
    CONDITIONAL_FLAG: 'ConditionalFlag',
    TAG_NAME: 'TagName',
    TAG_NAME_FORMAT: 'TagNameFormat',
    SCHEDULER_START_DATE: 'start_date',
    SCHEDULER_JOB_NAME: 'job_name',
    SCHEDULER_IS_DISABLED: 'isdisabled',
    EBS_APPLIES_TO: 'EBSAppliesTo',
    EBS_ANALYSIS: 'Analysis',
    ANALYSIS: 'ANALYSIS',
    PROCESS_NAME: 'Process Name',
    ATTACH_PROCESS: 'AttachProcess',
    ChildElementPath: 'ChildElementPath',
    CONDITIONAL_LOGIC: 'ConditionalLogic',
    ACTIVITY_SOP: 'SOP',
    PROCESSNAME: 'ProcessName',
    ACTIVITY_VIEW_MODE: 'EnableViewMode',
    ACTIVITY_EXECUTOR: 'ExecutorRoleID',
    ACTIVITY_WIDGET_NAME: 'DefaultWidgetName',
    ACTIVITY_APP_ID: 'APPID',
    SLA_START_ACTIVITY: 'StartActivityElementVersionID',
    SLA_END_ACTIVITY: 'EndActivityElementVersionID',
    SLA_HIGH_ACTIVITY: 'SLAHighCriticalElement',
    SLA_MEDIUM_ACTIVITY: 'SLAMediumCriticalElement',
    SLA_LOW_ACTIVITY: 'SLALowCriticalElement',
    SLA_OVERRIDDEN: 'IsSLAOverridableAtInstance',
    SLAACTIVEON: 'SLAActiveOn',
    ACTIONON: 'Action On',
    SUPPORTED_ELEMENTS: 'SupportedElements',
    COPY_FORM: 'CopyForm',
    ATTACH_APPS: 'AttachApps',
    PROCESS_SLA_HIGH_ACTIVITY: 'SLAHighCriticalProcess',
    PROCESS_SLA_MEDIUM_ACTIVITY: 'SLAMediumCriticalProcess',
    PROCESS_SLA_LOW_ACTIVITY: 'SLALowCriticalProcess',
    PROCESS_SLA_START_LIMIT: 'SLAStartLimit',
    PROCESS_SLA_END_LIMIT: 'SLAEndLimit',
    PROCESS_SLA_SUB_PROCESS: 'UseSubProcessSLA',
    PROCESS_SLA_DISPLAY_ORDER: 'SLAOrder',
    PROCESS_SLA_DISPLAY_NAME: 'SLAName',
    IS_ACTION_ON_ROOT_CAUSE_ELEMENT: 'IS_ACTION_ON_ROOT_CAUSE_ELEMENT',
    REPORT_DATE: 'Report Date',
    __MIN_DATE: '__MIN_DATE',
    __MAX_DATE: '__MAX_DATE',
    PLANNER_MORE_OPTIONS: 'PlannerMoreOptions',
    EDIT: 'Edit',
    DETAILS: 'Details',
    JOB_ID: 'JobID',
    JOB_NAME: 'JobName',
    IS_DISABLED: 'IsDisabled',
    REF_ELEMENTVERSION_ID: 'RefElementVersionID',
    ROLE: 'Role',
    TASK_CREATOR_PLAN_OPTION: 'CanSchedule',
    TYPE: 'Type',
    OPEN_IN_SLIDER: 'IS_OPEN_IN_SLIDER',
    UNIQUE_PATH: 'UniquePath',
    ALLOW_MULTIPLE_INSTANCE: 'AllowMultipleInstance',
    INSTANCE_OPEN_IN_SLIDER: 'InstanceOpenInSlider',
    ISGROUP: 'IsGroup',
    RENDER_IN_GRID_MODE: 'GRID_MODE',
    SHOW_IN_WIDGET_HEADER: 'ShowInWidgetHeader',
    TAGGED_APPS: 'TaggedApps',
    IS_REPORT: 'IsReport',
    QUERY_OPERATION: 'QueryOperation',
    FORMULA_EXPRESSION: 'FormulaExpression',
    APP_APPLIES_TO: 'AppAppliesTo',
    WIDGET_APPLIES_TO: 'WidgetAppliesTo',
    APPLY_FOR_ALL_WIDGETS: 'ApplyForAllWidgets',
    ATTACHPROCESS: 'AttachProcess',
    CONNECTED_ELEMENT_WIDGET_PARAMS: 'ConnectedElementWidgetParams'
  };

  public static processConfigurationNames = {
    PROCESS_CONFIGURATION: 'Process Configuration',
    FORM_CONFIGURATION: 'Form Configuration',
    EBS_CONFIGURATION: 'EBS Configuration'
  };

  public static processConfigurationIds = {
    FORM_CONFIGURATION: 8670
  };

  public static FilteredQuery = {
    DATA_FORMULA: 'DataSource_Formula',
    EMPTY_QUERY: 'EmptyQuery'
  };

  public static SchedulerClassName = {
    STATE_MACHINE_PROCESS: 'SchedulerTestjob.TriggerStateMachineProcess',
    SEQUENTIAL_MACHINE_PROCESS: 'SchedulerTestjob.TriggerSequentialProcess'
  };

  public static ErrorCodes = {
    NotAValidElement: 11108
  };

  public static RoleElementVersionIds = {
    NIBRAS_ADMINISTRATOR: 287,
    PDO: 76648
  };

  public static RoleAssignmentElementTemlateVersionIds = {
    SecurityIdentity: 11004,
    ROLE_ASSIGNMENT: 10074,
    ASSIGNMENT_SCOPE: 14381,
    PERMISSION_READONLY: 14415,
    PERMISSION_READWRITE: 14416,
    CUSTOM_ROLE_ASSIGNMENT: 52686
  };
  public static RoleAssignmentAttributeTemplateIds = {
    END_DATE: 'EndDate', //83,
    IsDefault: 'IsDefault', // 224,
    DEFAULT_ROLE_ID: 'DefaultRoleID', //7187
    START_DATE: 'StartDate', //82,
    HIERARCHY_TYPE: 'HierarchyType', //82,
    RoleName: 15201
  };
  public static UserAttributeTemplateIds = {
    FirstName: 236,
    LastName: 242
  };
  public static SecurityAttributeTemplateIds = {
    IsGroup: 124
  };

  public static ConnectionQuery = {
    QUERYMANGER_ID: 2,
    QUERY_ATTRIBUTE_VERSION_ID: 1317,
    QUERY_ELEMENT_TYPE_ID: 1319,
    UOM_ID: 1321
    /* QUERY_ATTRIBUTE_VERSION_ID: 1451,
        QUERY_ELEMENT_TYPE_ID: 1453,
        UOM_ID: 1455,
        PARENT_ATTRIBUTETEMPLATE_ID:1454*/
  };

  public static LinkQuery = {
    QUERYMANGER_ID: 1216
  };

  public static TagQuery = {
    QUERYMANGER_ID: 1215
  };

  public static PersistentQuery = {
    QUERYMANGER_ID: 1234
  };

  public static PersistentDR = {
    QUERYMANGER_ID: 1225
  };

  public static WriteQuery = {
    QUERYMANGER_ID: 1223
  };

  public static FormulaDR = {
    QUERYMANAGER_ID: 1197, //Prod
    //QUERYMANAGER_ID: 1207, //Dev
    //QUERYMANAGER_ID: 61, //KPO
    QUERYMANAGER_NAME: 'FormulaDR'
  };

  public static EMPTY_QM = { QueryManagerID: 1, QueryManagerName: 'None' } as dcDataReference;

  public static ElementTemplateNames = {
    FORMULA_QUERY: 'FORMULA_QUERY'
  };

  public static ReportConstants = {
    ROW_UNIQUEID: 'ROW_UNIQUEID',
    ALL_TEXT: 'All',
    DATAKEY_CELL_PREFIX: '__dataKey__',
    SUMMARY_ROW: 'SUMMARY_ROW',
    IS_GOOD: '__isGood__',
    REPORT_COMPONENT_KEY: 'reportComponent',
    ROOT_ELEMENT_NAME: ',',
    //"TODO: These constants are specific to BSP, needs to implemented via nibras-hooks.service.ts"
    WELL_NAME_DASH_SPLIT: '-',
    CONNECTION_NAME_ARROW_SPLIT: '-->',
    WELL_NAME_SEPRATOR: '('
  };

  public static ElementTemplateVersionIds = {
    BT_DATAFUNCTIONS: 10000,
    SNAPSHOT: 10001,
    PLOTVALUES: 10005,
    TABLE_COMPONENT: 11018,
    FILE: 5052,
    HIERARCHY_RULE: 10775,
    FORMULA_QUERY: 22,
    PROCESS_APP_FILTER: 11045,
    WIDGET: 11017,
    TREND: 11015,
    TREND_CONTROL_GROUP: 10065,
    XAXIS_COLLECTION: 11039,
    XAXIS: 10067,
    YAXIS_COLLECTION: 11041,
    YAXIS: 11042
  };

  public static FormConfigurationExcludedElementTypes = [NFIdentity.DataFunction];

  public static readonly DataFunctionTags = {
    ELEMENT_TEMPLATE_VERSION_ID_SNAPSHOT: {
      SourceObjectID: 10001,
      TagName: 'SNAPSHOT',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSION_ID_RECORDEDVALUE: {
      SourceObjectID: 10002,
      TagName: 'RECORDEDVALUE',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSION_ID_RECORDEDVALUES: {
      SourceObjectID: 10003,
      TagName: 'RECORDEDVALUES',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSION_ID_RECORDEDVALUESBYCOUNT: {
      SourceObjectID: 10004,
      TagName: 'RECORDEDVALUESBYCOUNT',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSION_ID_PLOTVALUES: {
      SourceObjectID: 10005,
      TagName: 'PLOTVALUES',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSIONID_INTERPOLATED_VALUE: {
      SourceObjectID: 10006,
      TagName: 'INTERPOLATEDVALUE',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    //public static readonly ELEMENT_TEMPLATE_VERSIONID_INTERPOLATEDVALUE = 10007;
    // TODO: Duplicate is there in Current DB, check with SDK team
    ELEMENT_TEMPLATE_VERSIONID_INTERPOLATED_VALUES_BY_COUNT: {
      SourceObjectID: 10008,
      TagName: 'INTERPOLATEDVALUESBYCOUNT',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag,
    ELEMENT_TEMPLATE_VERSIONID_INTERPOLATED_VALUES: {
      SourceObjectID: 10007,
      TagName: 'INTERPOLATEDVALUES',
      ElementTypeID: NFIdentity.AttributeTemplate
    } as dcTag
  };

  /**
   * @deprecated The use ValueTypeClass: MultiSelect instead of this.
   */
  public static MultipleDropDownTypes: number[] = [45, 47];

  public static ValueTypeCategories = {
    AutoCompleteValueTypes: [
      ValueType.Element,
      ValueType.ElementTemplate,
      ValueType.AttributeTemplate,
      ValueType.Attribute,
      ValueType.RelativeDateTime,
      ValueType.ElementType,
      ValueType.Role,
      ValueType.Process,
      82, // TODO value missing in the enum
      ValueType.Apps
    ],
    DropdownValueTypes: [
      ValueType.ChartType,
      ValueType.XAxis,
      ValueType.YAxis,
      ValueType.AggregateDataMethods,
      ValueType.ProcessType,
      ValueType.ProcessPriority,
      ValueType.ProcessTrigger,
      ValueType.DataTransmissionMode,
      ValueType.ConditionalFormatting,
      ValueType.FileCategory,
      ValueType.XaxisPosition,
      ValueType.YaxisPosition,
      ValueType.DataMethods,
      ValueType.ChartSymbol,
      ValueType.ChartMarkPoint,
      ValueType.ColumnWidthStyle,
      ValueType.PivotAggregates,
      ValueType.PivotChartDataType,
      ValueType.XYPlotType,
      ValueType.Icon,
      ValueType.PivotChartType,
      ValueType.DateTimeOptions, // same as ValueType.SAPFunctionalLocation
      ValueType.QueryOperation, // same as ValueType.SAPConsequenceCategory
      ValueType.TextEntryTypes,
      ValueType.ConfigDropDownValues,
      ValueType.MetaDataLabels,
      ValueType.DateFormat,
      ValueType.ProcessViewerStatus,
      93, // TODO value missing in the enum
      ValueType.LimitSettingsView,
      ValueType.TextOrientation,
      ValueType.TableType,
      ValueType.SortType,
      ValueType.Frequency,
      ValueType.ChartLineType, // same as ValueType.ChartLineType
      ValueType.SwitchToLatestData,
      ValueType.Alignment,
      ValueType.PrintCommands,
      ValueType.AnalysisDefaultMode
    ],
    TagSearchValueTypes: [
      ValueType.dcTagMap,
      ValueType.Alignment,
      ValueType.Role,
      206 // TODO value missing in the enum
    ]
  };

  public static CustomDropDownValues: { [key: string]: string[] } = {
    Category: ['LOP', 'NFA', 'NEW_OIL'],
    WellTest: ['NFA2', 'NFA12', 'NEW_OIL2']
  };

  public static FormBuilderCategories = {
    DataContextTypes: [55988]
  };

  public static LimitsSettings = {
    GROUP_NAME_TEXT: 'GroupName',
    ANALYSIS_TEXT: AppConstants.AttributeNames.ANALYSIS,
    ANALYSIS_ELEMENT_PATH_TEXT: '.\\ANALYSIS',
    ROOT_ELEMENT_PATH_TEXT: '.',
    INTEGER_VALUE_50: 50,
    INTEGER_VALUE_100: 100,
    OE_ATTRIBUTE: 'OE',
    OE_MIN_ATTRIBUTE: 'OE_MIN',
    OE_MAX_ATTRIBUTE: 'OE_MAX',
    OE_HI_ATTRIBUTE: 'OE_HI',
    OE_LOW_ATTRIBUTE: 'OE_LOW',
    TARGET: 'OE_TARGET'
  };

  public static LimitsSettingsStyleConfig = {
    SINGLE_SERIES_COLOR: '#61798e',
    SINGLE_VIOLIN_COLOR: '#d0e2f2',
    COMBINED_SERIES_COLORS: ['#a1e496', '#ffcc7d'],
    AXIS_LINE_COLOR: '#d0e2f2',
    AXIS_LABEL_COLOR: '#61798e',
    AXIS_SPLIT_LINE_COLOR: '#d0e2f2',
    AXIS_SPLIT_AREA_COLOR: ['rgba(223, 242, 255, 0.3)', 'rgb(255, 255, 255)'],
    AXIS_DOTTED_BORDER: 'dotted',
    AXIS_SOLID_BORDER: 'solid'
  };

  public static LimitsSettingsOEAttributes = [
    AppConstants.LimitsSettings.OE_ATTRIBUTE,
    AppConstants.LimitsSettings.OE_MIN_ATTRIBUTE,
    AppConstants.LimitsSettings.OE_MAX_ATTRIBUTE,
    AppConstants.LimitsSettings.OE_HI_ATTRIBUTE,
    AppConstants.LimitsSettings.OE_LOW_ATTRIBUTE,
    AppConstants.LimitsSettings.TARGET
  ];

  public static AdvancedSankey = {
    RECORD_COUNT_TEXT: 'Record Count',
    WELL_COUNT_TEXT: 'Well Count'
  };

  public static TrendApp = {
    SELECTED_SUGGESTED_VALUE_TEXT: 'selectedSuggestedValues',
    SHOW_PARETO_TEXT: 'showPareto',
    TREND_DATA_LIST_TEXT: 'trendDataList',
    COMPONENT_PARAMETER_INTERVAL_DENOMINATOR_VALUE: 16,
    XY_VALUE_SPLITTER: ' - '
  };

  public static NFElementTemplates = {
    BT_BASE_ELEMENT: { ID: 10010, Name: 'BT_BASE_ELEMENT' },
    //START - Workflow
    ACTIVITY_INSTANCE: { ID: 6584, Name: 'ACTIVITY_INSTANCE' },
    PROCESS_INSTANCE: { ID: 6583, Name: 'PROCESS_INSTANCE' }
    //End - Workflow
  };

  public static ACTIONS = {
    TAGS_FROM_HOME_PAGE: 'tagsFromHomePage',
    USER_ROLEASSIGNMENT_APP_NAVIGATION: 'userRoleAssignmentAppNavigation',
    RELOAD_PROCESS_ELEMENT: 'reloadProcessElement',
    USER_ROLE_ELEMENTS: 'userRoleElements'
  };

  public static Trend = {
    CONCATENATION_TEXT: ' - ',
    TREND_WIDTH: 0.015,
    TREND_HEIGHT: 0.15,
    LEGEND_LEFT: '5%',
    DEFAULT_LEGEND_TOP: '1%',
    Y_AXIS_LABEL_SIZE: 20,
    X_AXIS_LABEL_SIZE: 20,
    DEFAULT_GRID_WIDTH: 70,
    TREND_COMPONENT_PERCENTAGE: 0.01,
    AXIS_LEFT_PERCENTAGE_TEXT: 'left',
    AXIS_RIGHT_PERCENTAGE_TEXT: 'right',
    AXIS_NAME_GAP: 5, // default value
    AXIS_LEFT_PERCENTAGE: 7,
    AIXS_MIN_VALUE: 'MIN_VALUE',
    AIXS_MAX_VALUE: 'MAX_VALUE',
    SERIES_MARK_AREA_TEXT: 'TimeLineEvents',
    SERIES_LINE_DEFAULT_COLOR: 'grey',
    DEFAULT_BAR_WIDTH: 10,
    DEFAULT_TREND_WIDTH: 2,
    DEFAULT_LEGENED_TYPE: 'scroll',
    DEFAULT_LEGEND_TYPE_SCROLL: 'scroll',
    DEFAULT_LEGEND_TYPE_PLAIN: 'plain',
    DEFAULT_GROUP_TEXT: 'DefaultGroup',
    DEFAULT_BARS: 15,
    FADED_OPACITY: 0.2,
    NORMAL_OPACITY: 1,
    HIDED_OPACITY: 0,
    FADED_COLOR: '#e0e0e0',
    DEFAULT_AXIS_COLOR: '#333',
    AXIS_ID: 'AXISID',
    AXIS_POSITION: 'AXIS_POSITION',
    TREND_TITLE_FONT_STYLE: {
      fontWeight: 'normal',
      fontSize: 13
    },
    GIS_COMPONENT_KEY: 'gisComponent',
    TREND_COMPONENT_KEY: 'trendComponent',
    WELL_NAME_SEPRATOR: '(',
    WELL_NAME_CHAR_SEPRATOR: 'ST1',
    TABLE_COMPONENT_KEY: 'tableComponent',
    POLY_LINE: 'polyline'
  };

  public static TrendZoom = {
    TYPE_SLIDER_TEXT: 'slider',
    TYPE_INSIDE_TEXT: 'inside',
    TIME_TEXT: 'time'
  };

  public static TrendSeries = {
    ITEM_SYMBOL_SIZE_TEXT: 'ITEM_SYMBOL_SIZE',
    ITEM_SYMBOL_TEXT: 'ITEM_SYMBOL',
    ITEM_COLOR_TEXT: 'ITEM_COLOR',
    SERIES_COLOR_TEXT: 'SERIES_COLOR',
    SERIES_REGRESSION_COLOR_TEXT: 'SERIES_REGRESSION_COLOR',
    SERIES_SYMBOL_TEXT: 'SERIES_SYMBOL',
    SERIES_SYMBOL_SIZE_TEXT: 'SERIES_SYMBOL_SIZE',
    SHOW_MARK_LINE_TEXT: 'SHOW_MARK_LINE',
    SHOW_MARK_POINT_TEXT: 'SHOW_MARK_POINT',
    LINE_SYMBOL_SIZE_TEXT: 'LINE_SYMBOL_SIZE',
    LINE_SYMBOL_TEXT: 'LINE_SYMBOL',
    MARK_POINT_TEXT: 'markPoint',
    MARK_LINE_TEXT: 'markLine',
    SHOW_LEGEND_TEXT: 'SHOW_LEGEND',
    MARK_LINE_SYMBOL: 'MARK_LINE_SYMBOL',
    MARK_LINE_LABEL: 'MARK_LINE_LABEL',
    MARK_LINE_TYPE: 'MARK_LINE_TYPE',
    X_AXIS: 'xAxis',
    Y_AXIS: 'yAxis',
    X_AXIS_ID: 'XAXIS_ID',
    Y_AXIS_ID: 'YAXIS_ID',
    DEFAULT_BAR_GAP: '10%',
    NEW_Y_AXIS_TEXT: 'New Y-Axis',
    SERIES_CHART_TYPE_TEXT: 'CHART_TYPE'
  };

  public static DataContext = {
    ELEMENT_PATH: '.\\PersistentData'
  };

  public static NewFormulaDataReference = {
    FORMULA_QUERYMANGER_NAME: 'Formula',
    QUERYMANGER_ID: -2,
    FORMULA_OBJECT_NAME: 'DataSoure_Formula'
  };

  public static constantTags = {
    BASE_APP_TAG: {
      TagName: 'BT_APP',
      TagID: 0,
      ElementTypeID: NFIdentity.Element
    } as dcTag,
    BASE_ELEMENT_TYPE_SEARCH_TAG: {
      TagID: -1,
      CategoryID: TagCategory.ElementSelfTag
    } as dcTag,
    CATEGORY_FILETR_TAG: {
      ElementTypeID: NFIdentity.Process_Category,
      TagName: 'ProcessCategory'
    } as dcTag,
    CATEGORY_SEARCH_TAG: {
      Target: [],
      IsElement: true,
      IsGroup: true
    } as dcSearchTags,
    PROCESS_CATEGORY_OSW_TAG: {
      ElementTypeID: NFIdentity.Process_Category,
      TagName: 'OSW',
      ObjectID: 5238
    } as dcTag
  };

  public static GISConstatnts = {
    minBubbleSize: 10,
    maxBubbleSize: 30,
    DEFAULT_PROXIMITY: 1,
    DEFAULT_PROXIMITY_UOM: 'km',
    NEARBY: 'NEAR BY ELEMENTS',
    GISVALUE: 'ATTRIBUTES',
    COLOR_TEXT: 'color',
    DEFAULT_BUBBLE_COLOR: '#E27728',
    BUBBLE_COLOR_TEXT: 'BubbleColor',
    FEATURE_LAYER: 'FeatureLayer',
    IMAGE_LAYER: 'ImageLayer'
  };

  public static NibrasTableRender = {
    BUTTON_RENDERER: 'buttonRenderer',
    CUSTOM_BUTTON_RENDERER: 'customButtonRenderer',
    ICON_RENDERER: 'iconRenderer',
    MENU_RENDERER: 'menuRenderer',
    FILEDOWNLOAD_RENDERER: 'fileDownloadRenderer',
    CHECKBOX_LABEL_CELL_RENDERER: 'checkboxLabelCellRenderer'
  };

  public static readonly ColorCodes = [
    '#899893',
    '#B9D991',
    '#038AE6',
    '#3aa255',
    '#be8663',
    '#e1c315',
    '#4dc4ff',
    '#975e6d',
    '#caa465',
    '#6569b0',
    '#e62969',
    '#b09733',
    '#27727B',
    '#f2684b',
    '#a2b029',
    '#FF4D4D',
    '#f89a1c',
    '#aeb92c',
    '#718933',
    '#4eb849',
    '#f68a5c',
    '#baa635',
    '#0aa3b5',
    '#9db2b7',
    '#76c0cb'
  ];

  public static readonly NibrasColorCodes = [
    '#00d1ff',
    '#6be600',
    '#333333',
    '#8b0000',
    '#ff0000',
    '#af7ac5',
    '#0085ff',
    '#13ae66',
    '#ff19ff',
    '#0a2898',
    '#ff0099',
    '#c28c00',
    '#f06f53',
    '#0038ff',
    '#506974',
    '#ff9900',
    '#00ffd1',
    '#ef8def',
    '#ccff00',
    '#ffc413',
    '#ff7a00',
    '#9e3dff',
    '#ffff1e',
    '#ff6984',
    '#b45600',
    '#c800e9',
    '#0089b3',
    '#2a5629',
    '#00c2c2',
    '#6b0a97'
  ];

  public static StatusColors = {
    INFO: 'info',
    WANRNING: 'warning',
    SUCCESS: 'success',
    DANGER: 'danger',
    INPROGRESS: 'inprogrees'
  };

  public static AlarmPriorities = {
    LOW: 'low-priority',
    MEDIUM: 'medium-priority',
    HIGH: 'high-priority'
  };

  public static NewAttributeTemplate = {
    ATTRIBUTE_TEMPLATE_ID: -1,
    ATTRIBUTE_TEMPLATE_DESCRIPTION: 'New Attribute'
  };
  public static DATAKEY_HIGH_LIMIT = 1000;

  public static REMEMBER_KEYS = {
    NEVER_ASK_VALUE: 'false',
    DX_MANAGER: { OPEN_IN_EDITOR_IF_TEMPLATE: 'Always open templates in Editor' }
  };

  public static CustomTrendSeriesXYZ = {
    WellName: 'Well Name',
    Sand: 'Sand',
    ZoneStatus: 'Zone Status',
    Zone: 'Zone',
    Block: 'Block',
    Platform: 'Platform',
    PerfThickness: 'Perf Thickness(AHDepth (M))',
    WellProdMethod: ' Well Prod Method'
  };

  public static readonly ANDON_APPID = 10300; //Cloud DB AppID: 743932  Dev AppID: 10300(Preloader), 772409 Replace with Dev/Prod/Stag ID

  public static PdfFormat = {
    A4: 0,
    A3: 1
  };

  public static PdfOrientation = {
    Portrait: 0,
    Landscape: 1
  };
}
